import $ from "jquery";

$(() => {
  const steps = $(".step-section-step");
  if (steps.length) {
    steps.each((i, stepEl) => {
      const step = $(stepEl);
      const showButton = step.children(".show-button")[0];
      const showArea = step.children(".step-copy")[0];

      console.log(showButton);

      $(showButton).on("click", function (e) {
        e.preventDefault();
        console.log("toggling");
        $(showArea).toggleClass("line-clamp-2");
        $(this).text(function (i, text) {
          return text === "Show less" ? "Show more" : "Show less";
        });
      });
    });
  }
});
